import { apiClient } from 'pobble-components/dist/api'

const apiDeleteOauthIdentity = id =>
  apiClient.delete(`/v3/oauth_identities/${id}`)

export { apiDeleteOauthIdentity }
